import { ProductScreenshot } from 'components/ProductScreenshot';
import CreateExperimentLight from "../../../../contents/images/features/experiments/create-experiment-light-mode.png";
import CreateExperimentDark from "../../../../contents/images/features/experiments/create-experiment-dark-mode.png";
import ExperimentGoalWarningLight from "../../../../contents/images/features/experiments/experiment-goal-warning-light-mode.png";
import ExperimentGoalWarningDark from "../../../../contents/images/features/experiments/experiment-goal-warning-dark-mode.png";
import { ProductVideo } from 'components/ProductVideo';
import SetExperimentLight from "../../../../contents/images/features/experiments/set-experiment-rollout-light-mode.mp4";
import SetExperimentDark from "../../../../contents/images/features/experiments/set-experiment-rollout-dark-mode.mp4";
import ImprovementCalculatorLight from "../../../../contents/images/features/experiments/improvement-calculator-light-mode.mp4";
import ImprovementCalculatorDark from "../../../../contents/images/features/experiments/improvement-calculator-dark-mode.mp4";
import * as React from 'react';
export default {
  ProductScreenshot,
  CreateExperimentLight,
  CreateExperimentDark,
  ExperimentGoalWarningLight,
  ExperimentGoalWarningDark,
  ProductVideo,
  SetExperimentLight,
  SetExperimentDark,
  ImprovementCalculatorLight,
  ImprovementCalculatorDark,
  React
};